
import '../index.css'
import React, {useRef} from "react";
import { AddUserDialog } from "./components/ActivateUserDialog";
import AuthService from "@/services/auth";
import {useNavigate} from "react-router-dom";
import Header from "@/components/header";

export default function Registration() {
    const navigator = useNavigate()
    const userInfo = AuthService.getUserInfo()

    // 创建弹窗引用
    const addUserDialogRef = useRef<{ open: () => void }>(null);
    // 新增成功后的回调
    const handleAddSuccess = (res:any) => {
        console.log(res);
        console.log("激活成功");

    };

    return (
        <div className="bg-background flex-1 flex flex-col" style={{"borderRadius": 16}}>
            <Header/>
            <div className="flex flex-1">
                {/* 激活弹窗*/}
                <AddUserDialog
                    onSuccess={handleAddSuccess}
                />

            </div>

        </div>
    );
}

